export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="container-pad py-20 max-w-3xl">
      <div className="overline">Legal</div>
      <h1 className="font-display text-5xl text-navy mt-4 tracking-tight">Privacy Policy</h1>
      <p className="text-muted2 mt-3 text-sm">Last updated: {new Date().toLocaleDateString("en-AU", { year: "numeric", month: "long" })}</p>

      <div className="prose prose-neutral max-w-none mt-10 space-y-6 text-ink leading-relaxed">
        <p>
          Elevate Consulting Pty Ltd ("we", "us", "our") respects your privacy and is committed to protecting your personal
          information in accordance with the Australian Privacy Principles and the <em>Privacy Act 1988</em> (Cth).
        </p>

        <h2 className="font-display text-2xl text-navy mt-10">1. Information we collect</h2>
        <p>
          We collect information you provide voluntarily when you contact us, request a guide, book a consultation, or
          create an account in our client portal. This may include your name, email address, phone number, organisation
          and service interests.
        </p>

        <h2 className="font-display text-2xl text-navy mt-10">2. How we use your information</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>To respond to your enquiries and deliver requested resources</li>
          <li>To provide and improve our consulting services</li>
          <li>To send periodic updates (only if you opt in)</li>
          <li>To comply with legal and regulatory obligations</li>
        </ul>

        <h2 className="font-display text-2xl text-navy mt-10">3. Data storage and security</h2>
        <p>
          Personal information is stored on secure cloud infrastructure with industry standard encryption. We retain
          information only as long as necessary to fulfil the purposes for which it was collected.
        </p>

        <h2 className="font-display text-2xl text-navy mt-10">4. Disclosure</h2>
        <p>
          We do not sell your information. We only share data with trusted service providers (e.g., email delivery,
          analytics) under strict confidentiality, and where required by law.
        </p>

        <h2 className="font-display text-2xl text-navy mt-10">5. Your rights</h2>
        <p>
          You may request access to, correction of, or deletion of your personal information at any time by emailing{" "}
          <a className="text-ochre underline" href="mailto:Jordan@elevateconsultingau.com">Jordan@elevateconsultingau.com</a>.
        </p>

        <h2 className="font-display text-2xl text-navy mt-10">6. Updates</h2>
        <p>
          We may update this policy from time to time. Material changes will be communicated via our website or by email
          where appropriate.
        </p>

        <p className="text-sm text-muted2 mt-10">
          For privacy concerns, contact us at <a href="mailto:Jordan@elevateconsultingau.com" className="text-ochre underline">Jordan@elevateconsultingau.com</a>.
        </p>
      </div>
    </div>
  );
}
